module.exports = __webpack_public_path__ + "static/media/Location_Book-Page5.db48df15.png";